import { Component, OnInit, Injector } from '@angular/core';
import { IForgotPasswordForm } from '../../forms/forgot-password-form/forgot-password-form.component';
import { AuthService, IEmailCodeResult } from '../../services/auth.service';
import { finalize } from 'rxjs/operators';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { INewPasswordForm } from '../../forms/new-password-form/new-password-form.component';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertService } from 'src/app/shared/services/alert.service';
import { HttpHelpers } from 'src/app/shared/helpers/http.helpers';
import { ModalController, NavParams } from '@ionic/angular';
import { SettingService } from 'src/app/shared/services/setting.service';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { LoginPageComponent } from '../login-page/login-page.component';
import { Router } from '@angular/router';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-forgot-password-page',
    templateUrl: './forgot-password-page.component.html',
    styleUrls: ['./forgot-password-page.component.scss'],
    standalone: false
})
export class ForgotPasswordPageComponent implements OnInit {
  title: string = "Nav.ForgotPassword";
  emailCode: IEmailCodeResult;
  forgotPasswordForm: IForgotPasswordForm;

  disableHeader: boolean = false;
  isPopup: boolean = false;
  mobile: boolean = false;

  logo!: SafeUrl;

  constructor(private router: Router,
              private auth: AuthService,
              private loader: LoaderService,
              private alertService: AlertService,
              //private translateService: TranslateService,
              private modalCtrl: ModalController,
              private injector: Injector,
              private analytics: AnalyticsService,
              public setting: SettingService,
              private translationService: TranslationService,
              private sanitizer: DomSanitizer) { }

  ngOnInit() {
    //this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.apiUrl("/Menu/GetMenuItemImage?name=" + this.setting.configuration.logoShortName));

    if(this.setting.configuration?.logoShortName) {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.apiUrl("/Menu/GetMenuItemImage?name=" + this.setting.configuration.logoShortName));
    } else if(this.setting.configuration?.logoUrl) {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.configuration?.logoUrl);
    } else {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(null);
    }
    //this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.configuration?.logoUrl);

    const navParams = this.injector.get(NavParams, null);
        
            
    try {
      if(navParams.get('disableHeader') != undefined) {
        this.disableHeader = navParams.get('disableHeader');
        this.isPopup = true;
      }
    } catch (e) {

    }

    if(this.isPopup) {
      if (window.innerWidth <= 600) {
        this.mobile = true;
  
        this.disableHeader = false;
      } else {
        this.mobile = false;
  
        this.disableHeader = true;
      }
    }
  }

  notReceivedAnyCode() {
    this.forgotPasswordForm = null;
    this.emailCode = null;
  }

  async onPasswordForgotFormSubmited(form: IForgotPasswordForm) {
    const loader = await this.loader.create();
    await loader.present();
    this.auth.emailCodeVerificationStart(form.email, "ForgotPassword", this.translationService.getLanguage())
      .pipe(finalize(() => {
        loader.dismiss();
      }))
      .subscribe((result) => {
        this.forgotPasswordForm = form;
        this.emailCode = result;
      },
      (res: HttpErrorResponse) => {
        if (res.status == 404) {
          this.alertService.showTranslate('FPW.NOT_PART_OF_LISTING_MSG');
        }
      });
  }

  async returnToAuthLogin(){
    if(this.setting.configuration.uIoptions?.loginToPopup) {
      this.closePopup();   

      // prevents crash if the undocked navbar is inside a popup
      const modal = await this.modalCtrl.create({
        component: LoginPageComponent,
        cssClass: 'login-popup-model',
        componentProps: {
          disableHeader: false
        }
      });

      
    
      modal.onWillDismiss()
        .then((result) => {
          
      });
    
      await modal.present();
    } else {
      this.router.navigateByUrl('/auth/login');
    }
  }

  async onChangePasswordForgotFormSubmited(form: INewPasswordForm) {
    const loader = await this.loader.create();
    await loader.present();
    this.auth.forgotPassword({
      Id: this.emailCode.EmailCodeId,
      RandomCode: form.verificationCode,
      NewPassword: form.password,
      NewPasswordConfirmation: form.confirmPassword
    })
      .pipe(finalize(() => {
        loader.dismiss();
      }))
      .subscribe((result) => {
        this.notReceivedAnyCode();
      }/*, (error: HttpErrorResponse) => {
        if (error.status == 500)
          this.alertService.showUnexpectedErrorMsg();
        else {
          const modelState = error.error.ModelState;

          if (!modelState) 
            return;

          for (let key in modelState) {
            let property = HttpHelpers.removePrefix(key, 'model.');
            property = property.charAt(0).toLowerCase() + property.slice(1);
            this.formErrors.set(property, modelState[key][0]);
            console.log(this.formErrors);
          }
        }
      }*/);
  }

  closePopup(){
    if(this.isPopup) {
      this.modalCtrl.dismiss();
    }
  }
}
